<template>
    <div class="videoMessage">
        <custom-video-player
            class="video-player-box"
            ref="videoPlayer"
            :src="videoSrc()"
            :max-width="260"
            :max-height="200"
            :playback-rates="[0.7, 1.0, 1.5, 2.0]"
            :muted="false"
            :timestamp="displayTimestamp"
            :timestamp-tooltip="timestampTooltip"
        />
    </div>
</template>

<script>
import CustomVideoPlayer from "../../../../common/CustomVideoPlayer.vue";
import DateUtil from "../../../../utils/DateUtil";

export default {
    name: "VideoMessage",
    components: {
        CustomVideoPlayer,
    },
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        displayTimestamp() {
            return this.formattedTimestamp();
        },
        timestampTooltip() {
            const timestamp =
                this.message?.raw?.createdDate ||
                this.message?.timestamp ||
                this.message?.createdAt ||
                this.message?.time ||
                this.message?.data?.createdDate ||
                this.message?.data?.createdAt ||
                this.message?.data?.timestamp ||
                this.message?.data?.time;
            if (!timestamp) return "";
            return DateUtil.formatDateTime(timestamp);
        },
    },
    methods: {
        videoSrc() {
            const asset = this.message?.raw?.asset;
            if (!asset) return null;
            const path = asset.path || "";
            if (path === "") return null;
            const isWhatsapp = path.indexOf("whatsapp") !== -1;
            const isInstagram = path.indexOf("instagram") !== -1;
            const isMessenger = path.indexOf("messenger") !== -1;
            const isTelegram = path.indexOf("telegram") !== -1;
            const isFacebook = path.indexOf("facebook") !== -1;
            const isTable = path.indexOf("tables/attachments") !== -1;
            const isUnipile = path.indexOf("unipile") !== -1;
            const isChat = path.indexOf("chat") !== -1;
            const isApiMessages = path.indexOf("api-messages") !== -1;
            const assetId = asset._id || asset.id;
            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger || isFacebook || isTable || isUnipile || isChat || isApiMessages
                    ? `https://static.supsis.live/${asset.path}`
                    : asset.v2Format && asset.cdnUrl
                    ? asset.cdnUrl
                    : `https://static.supsis.live/${asset.path}${assetId}${asset.ext ? "." + asset.ext : ""}`;
            return src;
        },
        formattedTimestamp() {
            const timestamp =
                this.message?.raw?.createdDate ||
                this.message?.timestamp ||
                this.message?.createdAt ||
                this.message?.time ||
                this.message?.data?.createdDate ||
                this.message?.data?.createdAt ||
                this.message?.data?.timestamp ||
                this.message?.data?.time;
            if (!timestamp) return "";
            return DateUtil.formatHour(timestamp);
        },
    },
};
</script>

<style lang="scss" scoped>
.videoMessage {
    display: block;
    max-width: 100%;
    min-width: 0;

    .video-player-box {
        max-width: 100% !important;
        min-width: 0;

        > div {
            max-width: 100% !important;
            min-width: 0;
        }

        ::v-deep .video-thumbnail {
            max-width: 100% !important;
            min-width: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/VideoMessage.vue